import { useQueryClient } from "@tanstack/react-query";
import { FC, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import {
  getListOrganizationsQueryKey,
  useListOrganizations,
} from "~/api/organizations/organizations";
import { useGetCurrentUser } from "~/api/users/users";
import { Loader } from "~/components/Loader";
import { PageLayout } from "~/components/PageLayout";
import { ROUTES } from "~/helpers";

const RootContent: FC = () => {
  const navigate = useNavigate();
  const { data, error } = useListOrganizations();
  const { data: currentUser } = useGetCurrentUser();
  const queryClient = useQueryClient();

  useEffect(() => {
    const homeOrg = data?.find(
      (org) => !currentUser?.guestInOrganizations?.includes(org.id!)
    );
    const targetOrg = homeOrg || data?.[0];
    const organizationId = targetOrg?.id;

    if (
      organizationId &&
      currentUser?.guestInOrganizations?.includes(organizationId)
    ) {
      navigate(ROUTES.ACCESS_DENIED);
      return;
    }

    if (organizationId) {
      navigate(ROUTES.CASES({ organizationId }));
    } else if (error) {
      if ((error as any).code === 401) {
        queryClient.invalidateQueries({
          queryKey: getListOrganizationsQueryKey(),
        });
      }
    }
  }, [data, error, navigate, queryClient, currentUser]);

  // if (data && data.length > 0) {
  //Hide demo case for all users
  // if (
  //   localStorage.getItem(SKY_ACCOUNT_CREATED) === "true" &&
  //   localStorage.getItem(SKY_LAST_TRANSCRIBED_TEXT)
  // ) {
  //   navigate(ROUTES.DEMO_CASE_GENERATION({ organizationId: data[0].id }));
  // } else {
  //   navigate(ROUTES.CASES({ organizationId: data[0].id }));
  // }
  // }

  return (
    <PageLayout>
      <div className="flex flex-col items-center gap-2 h-[70vh] justify-center">
        <Loader>
          <div className="text-center mt-4">
            <FormattedMessage
              id="noOrganizations"
              defaultMessage="Please wait. If loading persists, <support>contact support</support>."
              values={{
                support: (chunks) => (
                  <a
                    href="mailto:support@usesky.ai"
                    className="text-blue-500 hover:underline"
                  >
                    {chunks}
                  </a>
                ),
              }}
            />
          </div>
        </Loader>
      </div>
    </PageLayout>
  );
};

export const RootPage: FC = () => {
  return <RootContent />;
};
